import { useContext, useState, useEffect } from "react";
import { Paper, FormControlLabel, Switch } from "@mui/material";
import { useDrag } from "react-dnd";
import EditIcon from "@mui/icons-material/Edit";
import ProfileQuestionContext from "../../../contexts/ProfileQuestionContext";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

export const DraggableQuestion = ({ question, questionGroupId }) => {
  const { setEditQuestionData, requiredQuestions, setRequiredQuestions } = useContext(
    ProfileQuestionContext
  );
  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: "QUESTION",
    item: { _id: question._id, question: question.question },
    end: (item, monitor) => {
      if (!monitor.didDrop()) {
        // Call onDropOut only if the item was not dropped in a valid drop target
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));
  const [required, setRequired] = useState(false);

  useEffect(() => {
    if (questionGroupId && requiredQuestions.includes(question._id)) {
      setRequired(true);
    } else if (required && !requiredQuestions.includes(question._id)) {
      setRequired(false)
    }
  }, [requiredQuestions]);

  const getQuestion = async () => {
    const result = await request(`profilequestions?questionId=${question._id}`);
    if (result.success) {
      setEditQuestionData(result.question);
    }
  };

  const updateRequired = async () => {
    const body = {
      questionId: question._id,
      questionGroupId,
      required: !required
    };
    const result = await request("questiongroups/required", "post", body);
    if (result.success) {
      setRequiredQuestions([...result?.questionGroup?.required]);
      let msg;
      if (required === true) {
        msg = "Message no longer marked as required"
      } else {
        msg = "Message marked as required"
      }
      toast.success(msg);
    }
  };

  return (
    <Paper
      ref={dragRef}
      elevation={2}
      style={{
        padding: "10px",
        marginBottom: "5px",
        backgroundColor: "lightyellow",
        border: "1px solid black",
        opacity: isDragging ? 0.5 : 1,
        cursor: "move",
        display: "flex",
        // justifyContent: "space-between",
        flexDirection: "column",
        gap: 5,
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {question.systemLabel ? question.systemLabel : question.question}
        <EditIcon
          style={{ color: "grey", height: 30, cursor: "pointer" }}
          onClick={getQuestion}
        />
      </div>
      {questionGroupId ? (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            paddingLeft: 10,
          }}
        >
          <FormControlLabel
            control={<Switch size="small" checked={required} onChange={updateRequired}/>}
            label="Required"
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "14px",
              },
            }}
          />
        </div>
      ) : (
        <></>
      )}
    </Paper>
  );
};
